export default __webpack_public_path__ + "static/media/picon1.5265b946.png";